import {
  CashoutResponseApiWithTimer,
  setIdsRealTimeCashout,
  setSelectedBet,
} from 'features/dashboard/myBets/myBetSlice';
import { MieScommesseTableRow, TableFieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { MovimentiStatoScommessaEnum, MovimentiTipoScommessaEnum } from 'types/swagger';
import { RootState, useAppDispatch } from 'lib/centralStore';
import { breakpoint, isRealTimeCashoutEnabled } from 'utility/constant';
import { checkSession, populateItemMieScommesseDashboardRow } from 'utility/dashboard/functions';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useGetPlayTimeQuery, useGetScommesseQuery, useRealTimeCashoutQuery } from 'features/api/userSlice';
import { useRouter, withRouter } from 'next/router';

import { AppCenter } from 'components/appCenter/AppCenter';
import { DashboardCms } from 'lib/datoCms/queries/getDashboardPage';
import { DashboardUserData } from 'components/dashboardUserData';
import { GeolocatorWidget } from 'components/geolocatorWidget';
import { IlMioSaldo } from 'components/IlMioSaldo';
import { LayoutDashboad } from 'components/layoutDashboad';
import { LayoutPersonalArea } from 'components/layoutPersonalArea';
import { MieScommesseWrapperMobile } from 'components/mieScommesseWrapperMobile';
import { MyAccountCms } from 'lib/datoCms/queries/getMyAccountPage';
import { MyBonusCms } from 'lib/datoCms/queries/getMyBonusPage';
import { Navigation } from 'components/header/Header';
import { NextPage } from 'next';
import { NoResult } from 'components/noResult';
import { PlayTime } from 'components/playTime';
import { ScommesseResponseApiItem } from 'lib/api/scommesseResponseApi';
import { Sidebar } from 'components/sidebar';
import { SkeletonArea } from 'components/skeletonArea';
import { SnaiPlusLevel } from 'components/snaiPlusLevel';
import { TableScommesseAperte } from 'components/tableScommesseAperte';
import { WidgetWithdraw } from 'components/widgetWithdraw/WidgetWithdraw';
import { WithRouterProps } from 'next/dist/client/with-router';
import { Wrapper } from 'components/wrapper';
import format from 'date-fns/format';
import { isTruthy } from 'utility/functions';
import { setContentLoaded } from 'features/dashboard/snaiPlus/snaiPlusSlice';
import styles from './PageContent.module.scss';
import subDays from 'date-fns/subDays';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useGetProfileContractQuery } from 'features/api/apiSlice';
import { useInternalSession } from 'hooks/useInternalSession';
import { useSelector } from 'react-redux';
import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';
import classNames from 'classnames';

type Props = {
  sidebarNavigationList: Navigation[];
  dashboardPage: DashboardCms;
  myDataPageUrl: string;
  myBonusPage: MyBonusCms;
  myAccountPage: MyAccountCms;
} & WithRouterProps;

type PlaytimeFilter = {
  label: string;
  value: string;
};

const PageContent: NextPage<Props> = ({
  myBonusPage,
  sidebarNavigationList,
  dashboardPage,
  myDataPageUrl,
  myAccountPage,
}) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { session, isAuthenticated } = useInternalSession();

  const { doCheck } = useWindowSize();

  const [isMobile, isRowMobile] = doCheck([
    { comparer: enComparer.less, size: breakpoint.lg },
    { comparer: enComparer.less | enComparer.equal, size: breakpoint.sm },
  ]);

  const labelEventi = useGetLabelByKey('eventi');
  const labelPossibileVincita = useGetLabelByKey('possibile-vincita');
  const labelImportoGiocato = useGetLabelByKey('importo-giocato');
  const labelSport = useGetLabelByKey('sport');
  const labelSistema = useGetLabelByKey('sistema');
  const labelMultipla = useGetLabelByKey('multipla');
  const labelVerificaCashout = useGetLabelByKey('verifica-cashout');
  const labelSingola = useGetLabelByKey('singola');
  const labelConfermaCashout = useGetLabelByKey('conferma-cashout');

  const labels = useMemo(() => {
    return {
      labelEventi,
      labelPossibileVincita,
      labelImportoGiocato,
      labelSport,
      labelSistema,
      labelMultipla,
      labelVerificaCashout,
      labelSingola,
      labelConfermaCashout,
    };
  }, [
    labelEventi,
    labelPossibileVincita,
    labelImportoGiocato,
    labelSport,
    labelSistema,
    labelMultipla,
    labelVerificaCashout,
    labelSingola,
    labelConfermaCashout,
  ]);

  const playtimeFilters: PlaytimeFilter[] = [
    { label: dashboardPage.labelImporto, value: 'importoTot' },
    { label: dashboardPage.labelTempo, value: 'tempoTot' },
  ];
  const playtimePeriods: PlaytimeFilter[] = [
    { label: dashboardPage.labelQuestaSettimana, value: 'LW' },
    { label: dashboardPage.labelQuestoMese, value: 'LM' },
    { label: dashboardPage.labelQuestoAnno, value: 'LY' },
  ];
  const [currPlaytimeFilter, setCurrPlaytimeFilter] = useState(playtimeFilters[0]);
  const [currPlaytimePeriod, setCurrPlaytimePeriod] = useState(playtimePeriods[0]);
  // const [fetchTime, setFetchTime] = useState(format(new Date(), 'HH:mm'));

  //GET PROFILE
  const {
    data: profileContract,
    isLoading: profileIsLoading,
    isFetching: profileIsFetching,
    // isError: profileIsError,
  } = useGetProfileContractQuery(session?.user?.csmfCod, {
    skip: !isAuthenticated || !session?.user?.csmfCod,
  });

  //SCOMMESSE
  const startingDate = useMemo(() => {
    return format(zonedTimeToUtc(subDays(new Date(), 29), 'UTC'), "yyyy-MM-dd'T'HH:mm:ss.SSSX").toString();
  }, []);
  const endingDate = useMemo(() => {
    return format(zonedTimeToUtc(new Date(), 'UTC'), "yyyy-MM-dd'T'HH:mm:ss.SSSX").toString();
  }, []);

  //SHOWING ONLY SPORT
  const {
    data: scommesseResponse,
    isLoading: scommesseIsLoading,
    isFetching: scommesseIsFetching,
  } = useGetScommesseQuery(
    {
      dataDa: startingDate, //'2023-06-01T07:10:51.489Z',
      dataA: endingDate, //'2023-06-13T07:10:51.489Z',
      stato: MovimentiStatoScommessaEnum.Aperta,
      tipologia: MovimentiTipoScommessaEnum.Sport,
      // hasCashout: false,
      pagination: {
        pageSize: 6,
        pageNumber: 1,
      },
    },
    {
      pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
    }
  );

  const { blockedIdsRealTimeCashout, idsRealTimeCashout } = useSelector((store: RootState) => store.myBets);
  const blockedIdsRealTimeCashoutRef = useRef<CashoutResponseApiWithTimer[]>([]);
  const labelCashOut = useGetLabelByKey('cashout')!;

  const idsRealTimeCashoutRef = useRef<string[]>([]);

  useEffect(() => {
    if (scommesseResponse?.items?.slice(0, 6) && isRealTimeCashoutEnabled) {
      const ids = (scommesseResponse?.items ?? [])
        .slice(0, 6)
        .filter((item: ScommesseResponseApiItem) => item.hasCashout && item.idBiglietto)
        .map((item) => item.idBiglietto!);
      dispatch(setIdsRealTimeCashout(ids));
      idsRealTimeCashoutRef.current = ids;
    }
  }, [scommesseResponse, dispatch]);

  const { data: cashoutResponse } = useRealTimeCashoutQuery(idsRealTimeCashout, {
    pollingInterval: 5000,
    skip: idsRealTimeCashout.length === 0 || !isRealTimeCashoutEnabled,
    refetchOnMountOrArgChange: true,
  });

  //PLAYTIME
  const {
    data: playtimeResponse,
    isLoading: playtimeIsLoading,
    isFetching: playtimeIsFetching,
  } = useGetPlayTimeQuery({
    period: currPlaytimePeriod.value,
  });

  useEffect(() => {
    if (router.isReady) checkSession(router);
  }, [isAuthenticated, router]);

  const itemsMobile: TableFieldProps[][] | undefined = useMemo(() => {
    return (scommesseResponse?.items ?? []).slice(0, 6).map((item) => {
      const data: TableFieldProps[] = populateItemMieScommesseDashboardRow({
        item,
        labels,
        dispatch,
        blockedIdsRealTimeCashoutRef,
        idsRealTimeCashoutRef,
        blockedIdsRealTimeCashout,
        cashoutResponse,
      });
      return data;
    });
  }, [scommesseResponse, labels, blockedIdsRealTimeCashout, cashoutResponse, dispatch]);

  useEffect(() => {
    dispatch(setContentLoaded(true));
  }, [dispatch]);

  const goToDetail = (item: ScommesseResponseApiItem) => {
    if (item) {
      dispatch(setSelectedBet({ ...item, verticale: 'sport' }));
      router.push(`/dashboard/le-mie-scommesse`);
    }
  };

  return (
    isAuthenticated && (
      <LayoutPersonalArea>
        <Sidebar sidebarNavigationList={sidebarNavigationList} className={classNames({ [styles.hidden]: isMobile })} />
        <Wrapper
          bgColorTransparent
          noPaddingTop={!isMobile}
          noPaddingBottom
          noPaddingLeft={!isMobile}
          noPaddingRight={!isMobile}
        >
          {profileIsLoading || profileIsFetching ? (
            <LayoutDashboad>
              {/* {[1, 2].map((item) => (
                  <SkeletonArea key={item} height="16.07" internalClassName="noMargin" className={styles.skeleton} />
                  
                ))} */}
              <SkeletonArea key={1} height="16.07" internalClassName="noMargin" className={styles.firstSkeleton} />
              <SkeletonArea key={2} height="16.07" internalClassName="noMargin" className={styles.lastSkeleton} />
            </LayoutDashboad>
          ) : (
            <LayoutDashboad>
              <WidgetWithdraw cmsData={myAccountPage} className={styles.widgetWithdraw} />
              <DashboardUserData
                dashboardPage={dashboardPage}
                myDataPageUrl={myDataPageUrl}
                userData={{
                  userName: session?.user?.name ?? '',
                  lastAccess: session?.user?.lastLoginDate ?? '',
                  data: [
                    {
                      label: dashboardPage?.labelNome,
                      value: profileContract?.nome ?? '',
                    },
                    {
                      label: dashboardPage?.labelTelefono,
                      value: profileContract?.telefonoMobile ?? '',
                    },
                    {
                      label: dashboardPage?.labelMail,
                      value: profileContract?.email ?? '',
                    },
                  ],
                }}
                containerClassName={styles.dashboard}
              />
              <SnaiPlusLevel
                title={dashboardPage?.titoloSnaiPlus}
                description={dashboardPage?.descrizioneSnaiPlus}
                dashboardPage={dashboardPage}
                logoSnaiPi={dashboardPage.logoSnaiPi[0]}
                containerClassName={styles.snaiPlus}
              />
            </LayoutDashboad>
          )}

          <IlMioSaldo
            myBonusPage={myBonusPage}
            myAccountPage={myAccountPage}
            items={myBonusPage.internalMenu[0].linkList}
          />

          {playtimeIsFetching || playtimeIsLoading ? (
            <SkeletonArea height="37.9" />
          ) : (
            <PlayTime
              dashboardPage={dashboardPage}
              playtimePeriods={playtimePeriods}
              playtimeFilters={playtimeFilters}
              data={playtimeResponse && playtimeResponse?.items}
              currPlaytimePeriod={currPlaytimePeriod}
              setCurrPlaytimePeriod={setCurrPlaytimePeriod}
              currPlaytimeFilter={currPlaytimeFilter}
              setCurrPlaytimeFilter={setCurrPlaytimeFilter}
              avarageAmount={playtimeResponse && playtimeResponse?.importoMedio}
              avarageTime={playtimeResponse && playtimeResponse?.tempoMedio}
            />
          )}

          {scommesseIsLoading || scommesseIsFetching ? (
            <TableScommesseAperte dashboardPage={dashboardPage}>
              {!isMobile ? (
                [1, 2, 3, 4, 5, 6].map((item) => <SkeletonArea key={item} height="6" className="openBets" />)
              ) : (
                <SkeletonArea height="20" className="openBets" />
              )}
            </TableScommesseAperte>
          ) : (
            <TableScommesseAperte dashboardPage={dashboardPage}>
              {isTruthy(scommesseResponse?.items?.length) ? (
                !isRowMobile ? (
                  (scommesseResponse?.items ?? []).slice(0, 6).map((item, index) => {
                    const data: TableFieldProps[] = populateItemMieScommesseDashboardRow({
                      item,
                      labels,
                      dispatch,
                      cashoutResponse,
                      blockedIdsRealTimeCashout,
                      idsRealTimeCashoutRef,
                      blockedIdsRealTimeCashoutRef,
                      labelCashOut,
                    });
                    return (
                      <MieScommesseTableRow
                        onClick={() => goToDetail(item)}
                        key={index}
                        columns={data}
                        isGridFiveColumns
                        internalClassName="openBets"
                      />
                    );
                  })
                ) : (
                  <MieScommesseWrapperMobile
                    arrayData={itemsMobile}
                    internalClassName="openBets"
                    scommesseResponse={scommesseResponse}
                    labels={labels}
                  />
                )
              ) : (
                <NoResult noMargin label={dashboardPage.labelNessunaScommessaAperta} />
              )}
            </TableScommesseAperte>
          )}
          <div
            className={
              dashboardPage.isActiveGeolocatorWidget && !!dashboardPage.leNostreAppBlock?.length
                ? styles.wrapperAppGeo
                : styles.wrapperApp
            }
          >
            {!!dashboardPage.leNostreAppBlock?.length && <AppCenter leNostreApp={dashboardPage.leNostreAppBlock} />}
            {dashboardPage.isActiveGeolocatorWidget && <GeolocatorWidget title={dashboardPage.titleGeolocatorWidget} />}
          </div>
        </Wrapper>
      </LayoutPersonalArea>
    )
  );
};

export default withRouter(PageContent);
